function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 732.448,
  y: 442.812,
  width: 30.771,
  height: 30.771,
  transform: "matrix(1,0,0,1,0,0)",
  id: "Rechteck",
  fill: "none",
  vectorEffect: "",
  strokeWidth: 3,
  stroke: "rgb(0,0,0)",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 2
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 741.533,
  y1: 472.869,
  x2: 733.025,
  y2: 464.361,
  id: "Strecke",
  vectorEffect: "",
  strokeWidth: 3,
  stroke: "rgb(0,0,0)",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 3
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 751.518,
  y1: 472.447,
  x2: 733.307,
  y2: 454.236,
  id: "Strecke",
  vectorEffect: "",
  strokeWidth: 3,
  stroke: "rgb(0,0,0)",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 3
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 761.643,
  y1: 471.885,
  x2: 733.799,
  y2: 444.041,
  id: "Strecke",
  vectorEffect: "",
  strokeWidth: 3,
  stroke: "rgb(0,0,0)",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 3
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 755.104,
  y1: 444.146,
  x2: 762.557,
  y2: 451.6,
  id: "Strecke",
  vectorEffect: "",
  strokeWidth: 3,
  stroke: "rgb(0,0,0)",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 3
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 744.064,
  y1: 443.514,
  x2: 762.275,
  y2: 461.725,
  id: "Strecke",
  vectorEffect: "",
  strokeWidth: 3,
  stroke: "rgb(0,0,0)",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 3
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 733.939,
  y1: 444.076,
  x2: 761.783,
  y2: 471.92,
  id: "Strecke",
  vectorEffect: "",
  strokeWidth: 3,
  stroke: "rgb(0,0,0)",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 3
});

var SvgFullscreenIcon = function SvgFullscreenIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "713.167 422.833 69 69",
    width: "25px",
    height: "25px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 723.907 424.333 L 771.427 424.333 C 776.526 424.333 780.667 428.474 780.667 433.573 L 780.667 481.093 C 780.667 486.193 776.526 490.333 771.427 490.333 L 723.907 490.333 C 718.807 490.333 714.667 486.193 714.667 481.093 L 714.667 433.573 C 714.667 428.474 718.807 424.333 723.907 424.333 Z",
    style: {
      stroke: "none",
      fill: "#E6E2E6",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 723.907 424.333 L 771.427 424.333 C 776.526 424.333 780.667 428.474 780.667 433.573 L 780.667 481.093 C 780.667 486.193 776.526 490.333 771.427 490.333 L 723.907 490.333 C 718.807 490.333 714.667 486.193 714.667 481.093 L 714.667 433.573 C 714.667 428.474 718.807 424.333 723.907 424.333 Z",
    style: {
      fill: "none",
      stroke: "#C6C6C6",
      strokeWidth: 3,
      strokeLinecap: "square",
      strokeMiterlimit: 2
    }
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFullscreenIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fullscreen-icon.daffd141.svg";
export { ForwardRef as ReactComponent };